import { arrayOf, shape, string, number, oneOfType } from 'prop-types';

export default arrayOf(
    shape({
        type: string,
        operator: string,
        key: string,
        value: oneOfType([
            string,
            number,
            shape({ min: number, max: number }),
            arrayOf(string),
        ]),
    }),
);
